// Delete Holiday Api//

import { setLocalStorageItem } from 'hooks';
import { useMutation, useQueryClient } from 'react-query';
import { useAPI } from 'services/axios';

import { Endpoints, queryKeys } from '../constants';

// Upload profile image api //
const uploadProfileImageApi = (payload: any) => {
  return useAPI({
    method: 'PATCH',
    url: `${Endpoints.SETTING_UPLOAD}`,
    headers: { 'content-type': 'multipart/form-data' },
    data: payload,
  });
};

export const useUploadProfileImageApiQuery = () => {
  const queryClient = useQueryClient();
  return useMutation(uploadProfileImageApi, {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.AUTH_ME]);
    },
  });
};

// Delete Profile image api //

const deletePictureApi = () => {
  // const { bUuid, contentId } = data;
  return useAPI({
    method: 'DELETE',
    url: `${Endpoints.SETTING_UPLOAD}`,
  });
};

export const useDeletePictureApiQuery = () => {
  const queryClient = useQueryClient();
  return useMutation(deletePictureApi, {
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.AUTH_ME);
      setLocalStorageItem('profileImage', '');
    },
  });
};

// Update information of users  Post api//
const updateInfoApi = (payload: any) => {
  return useAPI({
    method: 'POST',
    url: `${Endpoints.SETTING_UPDATE}`,
    data: payload,
  });
};

export const useUpdateInfoApiQuery = () => {
  const queryClient = useQueryClient();
  return useMutation(updateInfoApi, {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.AUTH_ME]);
    },
  });
};
